import service from "./../service.js";

export default {
  subscribeEFT(payload) {
    return service.post("/services/eft", payload);
  },
  getBanks() {
    return service.get("/services/eft/banks");
  },
};
